import React from 'react'
import LazyLoad from 'react-lazyload'
import { resizeShopifyImage } from '@helpers/shopify'
import styles from './styles.module.scss'

type ProductCardImageProps = {
  img: string
  imageConfig: {
    imgWidth: string
    imgHeight: string
  }
  title: string
  classes?: string
}

const ProductCardImage = ({
  img,
  imageConfig = {
    imgWidth: '328',
    imgHeight: '432'
  },
  title,
  classes = ''
}: React.PropsWithChildren<ProductCardImageProps>) => {
  const src =
    !img || img === ''
      ? 'https://cdn.shopify.com/s/files/1/0076/2131/2569/files/NoProductImageAvailable.jpg'
      : resizeShopifyImage(img, {
          width: imageConfig.imgWidth,
          height: imageConfig.imgHeight,
          crop: 'center'
        })

  return (
    <div className={`${styles.image__container} ${classes || ''}`}>
      <LazyLoad>
        <img src={src} alt={title} />
      </LazyLoad>
    </div>
  )
}

export default ProductCardImage
